import styled from 'styled-components';
import colors from '../../styles/theme/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: 100vh;
  width: 100%;
  background-color: #ffffff;
`;

export const Message = styled.p`
  font-size: 16px;
  color: ${colors.gray.primary};
  margin: 0;
`;
